import css from 'styled-jsx/css';
import { colors, typography, zIndex } from '../../../config/styles';

export const SideDrawerStyles = css`
  .right-drawer-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    z-index: 100;
    pointer-events: none;
  }

  .right-drawer-overlay.is-open {
    opacity: 1;
    pointer-events: auto;
  }

  .right-drawer-container {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    background-color: ${colors.white.shade1};
    transform: translateX(100%);
    transition: transform 0.5s ease-in-out;
    z-index: ${zIndex.drawer.container};
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    border-radius: 16px 0 0 16px;
    will-change: transform;
    max-width: 360px;
    min-width: 360px;
  }
  @media (max-width: 600px) {
    .right-drawer-container {
      max-width: 100vw;
      min-width: 0;
      width: 100vw;
      border-radius: 16px 16px 0 0;
      top: auto;
      bottom: 0;
      right: 0;
      left: 0;
    }
  }

  .right-drawer-container.is-open {
    transform: translateX(0);
  }

  .right-drawer-header {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid ${colors.gray.shade2 || '#eee'};
  }
  .right-drawer-header.zone-header-screen {
    @media (max-width: 600px) {
      position: absolute;
      top: 0;
      z-index: 1;
      border: 0;
    }
  }
  .drawer-line {
    @media (max-width: 600px) {
      width: 40px;
      height: 5px;
      border-radius: 5px;
      background: #a9b5c0;
      display: flex;
      align-self: center;
      margin: 0 auto;
    }
  }

  .close-drawer {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    @media (max-width: 600px) {
      padding-bottom: 6px;
    }

    .csicon-danger {
      font-size: 13px;
    }
    .close-icon-screen {
      @media (max-width: 600px) {
        font-size: 11px;
        border-radius: 280px;
        background-color: #333333ad;
        padding: 12px;
        color: ${colors.white.shade1 || '#fff'};
      }
    }
  }

  .right-drawer-container :global(.doc-click-overlay) {
    height: 100%;
    width: 100%;
    align-items: flex-start;
    flex-direction: column;
    @mixin phabletToDesktop {
      position: relative;
      align-items: inherit;
      justify-content: inherit;
    }
  }

  .right-drawer-header .close-button {
    font-size: 24px;
    color: ${colors.gray.shade45 || '#777'};
    cursor: pointer;
    background: none;
    border: none;
    padding: 5px;
  }
  .no-border {
    border: none;
  }

  .right-drawer-content {
    flex-grow: 1;
    overflow-y: auto;
    @media (max-width: 600px) {
      border-radius: 16px 16px 0 0;
      overflow: hidden;
      width: 100%;
    }

    .drawer-busy-overlay {
      position: absolute;
      inset: 0;
      z-index: ${zIndex.loader.overlay};
      font-size: ${typography.base};
      display: flex;
      background: linear-gradient(135deg, #fafafa, #fdfdfd);
      opacity: 0.6;
    }
  }
`;

export const SideDrawerStylesGlobal = css.global`
  body.no-scroll {
    overflow: hidden;
  }
  body.drawer-active {
    overflow: hidden;
    width: 100%;
  }
`;
